import React, { useState } from 'react';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents'; import { useSelector } from 'react-redux';

export default function AuxSidebar(props) {
  const {
    title,
    children,
    onClose,
    isOpen = false,
    width = '200px',
    position = 'left',
  } = props;
  const isSidebarOpened = useSelector((state) => state.auth?.settings?.preferences?.sidebar?.isOpened);
  const [sidebarPosition, setSidebarPosition] = useState(position);

  return (
    <AuxSidebarContainer width={isOpen ? width : '0px'} margin={sidebarPosition === 'left' ? (isSidebarOpened ? '200px' : '50px') : 0} position={sidebarPosition}>
      <AuxSidebarContent width={width}>
        <span
          className="float-right pointer"
        >
          <AppRemixIcon
            icon="arrow-left-right"
            onClick={() => (sidebarPosition === 'left' ? setSidebarPosition('right') : setSidebarPosition('left'))}
          />
          <AppRemixIcon
            icon="close"
            className="ml-2"
            onClick={() => onClose()}
          />
        </span>
        <h6 className="ml-2">{title}</h6>
        <AuxSidebarChildrenContainer>
          {children}
        </AuxSidebarChildrenContainer>
      </AuxSidebarContent>
    </AuxSidebarContainer>
  );
}

const AuxSidebarContainer = styled.div`
    position: fixed;
    left: ${(props) => (props.position === 'left' ? props.margin : 'auto')};
    right: ${(props) => (props.position === 'right' ? props.margin : 'auto')};
    top: 40px;
    bottom: 0px;
    width: ${(props) => props.width};
    overflow:hidden;
    background-color: white;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    z-index:20;
    transition: all ease 0.4s;
    height: 100%;
    `;
const AuxSidebarContent = styled.div`
    padding:6px;
    width: ${(props) => props.width};
`;
const AuxSidebarChildrenContainer = styled.div`
    height: calc(100vh - 80px);
    overflow-x: hidden;
    overflow-y: auto;
`;
